import { createSlice } from "@reduxjs/toolkit";
import { fetchDealsFundraisingCapacityThunk } from "./dealCapacity.actions";
import { DealFundraisingCapacity } from "./dealCapacity.types";

export interface DealCapacityState {
  byDealId: Record<string, DealFundraisingCapacity>;
  loading: boolean;
}

export const INITIAL_STATE: DealCapacityState = {
  byDealId: {},
  loading: false,
};

const dealCapacitySlice = createSlice({
  name: "dealCapacity",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchDealsFundraisingCapacityThunk.pending,
      (state: DealCapacityState) => {
        state.loading = true;
      }
    );
    builder.addCase(
      fetchDealsFundraisingCapacityThunk.rejected,
      (state: DealCapacityState) => {
        state.loading = false;
      }
    );
    builder.addCase(
      fetchDealsFundraisingCapacityThunk.fulfilled,
      (state: DealCapacityState, { payload }) => {
        state.loading = false;
        // Merge, not replace: a single-deal refetch must not drop the list cache.
        Object.assign(state.byDealId, payload);
      }
    );
  },
});

export default dealCapacitySlice.reducer;
